import { ClientInstance, AsyncResponse } from './Clients/AxiosClient'
export type { ClientInstance, AsyncResponse }

export class BaseRepository {
  constructor(public client: ClientInstance) {}
}